"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
const Block = ({
  children = null,
  className,
  ...rest
}) => _react.default.createElement(_styles.Box, (0, _extends2.default)({
  className: className
}, rest), children);
var _default = exports.default = Block;